import classNames from "classnames";
import React, { useMemo } from "react";
import { localize } from "src/l10n";
import { Label } from "src/ui";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { ErrorFallbackProps } from "./ErrorFallback.types";

function ErrorFallback({
}: ErrorFallbackProps): JSX.Element {
    const innerHtml = useMemo(() => ({
        __html: localize("COMPONENT_CRASH_TEXT")
    }), []);

    return (
        <div role="alert" className="ErrorFallback">
            <div className="icon">
                <Visage2Icon icon="triangle" />
            </div>
            <Label
                className="ErrorBoundaryContent"
                size="body-2"
            >
                <div className="ErrorBoundaryText"
                     dangerouslySetInnerHTML={innerHtml} />
            </Label>
        </div>
    );
};

export default ErrorFallback;

